export default "__VITE_ASSET__Bc7G3EIO__"